import React, { useContext, useEffect, useState } from "react";
import axios from "../axios/axios";
import Context from "../../Context/Context";
import "../../styles/HomeCaptacao.css";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { RiDeleteBin5Fill } from "react-icons/ri";
import NotificacaoDeErro from '../Notificacao/NotificacaoDeErro'
import NotificacaoDeSucesso from '../Notificacao/NotificacaoDeSucesso'

const campos = [
  "data_captacao",
  "data_ultima_vista",
  "processo",
  "estado",
  "nomenclatura_captada",
  "vara",
  "foro",
  "juizo",
  "situacao",
  "valor_acao",
  "adv_constituido",
  "tipo_captacao",
  "advogado",
  "escritorio",
  "cidade",
  "bairro",
  "observacoes_captador",
  "relatorio",
  "responsavel",
  "status",
  "num_bens",
  "telefone",
  "email",
  "valor_avaliacao",
  "classificacao_imovel",
  // "diretorio", // Novo campo
  "endereco_completo", // Novo campo
];

const mapInd = {
  id: "ID",
  data_captacao: "Data Captação",
  data_ultima_vista: "Data Última Vista",
  processo: "Processo",
  estado: "Estado",
  nomenclatura_captada: "Nomenclatura Captada",
  vara: "Vara",
  foro: "Foro",
  juizo: "Juízo",
  situacao: "Situação",
  valor_acao: "Valor da Ação",
  adv_constituido: "Advogado ConstituÍdo",
  tipo_captacao: "Tipo de Captação",
  advogado: "Advogado",
  escritorio: "Escritório",
  cidade: "Cidade",
  bairro: "Bairro",
  observacoes_captador: "Observações do Captador",
  relatorio: "Relatório",
  responsavel: "Responsável",
  status: "Status",
  num_bens: "Número de Bens",
  telefone: "Telefone",
  email: "Email",
  valor_avaliacao: "Valor de Avaliação",
  classificacao_imovel: "Classificação Imóvel",
  // diretorio: "Diretório",
  endereco_completo: "Endereço Completo",
};

function AvaliacaoForm() {
  const { usuario } = useContext(Context);
  const [avaliacao, setAvaliacao] = useState(
    {
      data_captacao: "",
      data_ultima_vista: "",
      processo: "",
      estado: "",
      nomenclatura_captada: "",
      vara: "",
      foro: "",
      juizo: "",
      situacao: "",
      valor_acao: "",
      adv_constituido: 0,
      tipo_captacao: "Mediata",
      advogado: "",
      escritorio: "",
      cidade: "",
      bairro: "",
      observacoes_captador: "",
      relatorio: "",
      responsavel: "",
      status: "",
      num_bens: "",
      telefone: "",
      email: "",
      valor_avaliacao: "",
      classificacao_imovel: "",
      diretorio: "",
      endereco_completo: "",
      status: "Captado"
    }
  );
  const [avaliacoes, setAvaliacoes] = useState([])
  const [page, setPage] = useState(0)
  const [editando, setEditando] = useState(false)
  const [index, setIndex] = useState(null)
  const [filtrando, setFiltrando] = useState(false)
  const [filters, setFilters] = useState({})
  const [msn, setMsn] = useState('')
  const [mostrarNotificacaoDeErro, setMostrarNotificacaoDeErro] = useState(false)
  const [mostrarNotificacaoDeSucesso, setMostrarNotificacaoDeSucesso] = useState(false)


  const getAvaliacoes = async (e) => {
    try {
      const { data }= await axios.get('/avaliacao') 
       setAvaliacoes(data)
      } catch (error) {
        setMsn(error)
        setMostrarNotificacaoDeErro(true)
    }
  };

  useEffect(() => {
    getAvaliacoes();
  }, []);

  // useEffect(() => {
  //   getAvaliacoes()
  //   if (props.editing) {
  //     setAvaliacao({ ...avaliacao, ...props.avaliacaoAntiga });
  //   } else {
  //     setAvaliacao({
  //       nomenclatura_captada: "",
  //       estado: "",
  //       relatorio: "",
  //       tipo_captacao: "Mediata",
  //       diretorio: "",
  //       endereco_completo: ""
  //     });
  //   }
  // }, []);

  // useEffect(() => {

  // }, [page])

  const verifyData = (data) => {
    const dataChecked = {};
    if (data.data_captacao && !data.data_captacao?.includes("T"))
      data.data_captacao = new Date(data.data_captacao + " ").toISOString();
    if (data.data_ultima_vista && !data.data_ultima_vista?.includes("T"))
      data.data_ultima_vista = new Date(
        data.data_ultima_vista + " ",
      ).toISOString();
    Object.keys(data).forEach((e) =>
      data[e]?.length >= 1 && campos.includes(e)
        ? (dataChecked[e] = data[e])
        : false,
    );
    return dataChecked;
  };

  const sortByDate = (data) => {
    return data.sort(
      (a, b) => new Date(b.data_captacao) - new Date(a.data_captacao),
    );
  };

  const formatDate = (data) => {
    return data?.split("T")[0].split("-").reverse().join("/");
  };

  const updateAvaliacao = async (e) => {
    e.preventDefault();
    console.log(avaliacao);
    const id = avaliacao.id; // + 1 aft -1
    delete avaliacao["id"];
    const checkedData = verifyData(avaliacao);
    checkedData["num_bens"] = +checkedData.num_bens || 0;
    // checkedData["responsavel_id"] = usuario.id;
    checkedData["adv_constituido"] = +checkedData.adv_constituido;
    checkedData["valor_acao"] = checkedData?.valor_acao?.toString() || "";

    try {
      const { data } = await axios.put(`/avaliacao/${id}`, checkedData);
      // props.setAvaliacao([...props.avaliacao, data]);
      avaliacoes[index] = { ...data }
      setAvaliacoes(avaliacoes)
      setMsn('Avaliação atualizada com sucesso!')
      setMostrarNotificacaoDeSucesso(true)
      setEditando(false)
    } catch (error) {
      setMsn(error)
      setMostrarNotificacaoDeErro(true)
    }
  };

  // const createAvaliacao = async (e) => {
  //   e.preventDefault();
  //   const checkedData = verifyData(avaliacao);
  //   // checkedData["responsavel_id"] = usuario.id;
  //   checkedData['num_bens'] = +checkedData.num_bens || 0;
  //   checkedData['adv_constituido'] = +checkedData.adv_constituido;
  //   checkedData['valor_acao'] = checkedData?.valor_acao?.toString() || "";

  //   try {
  //     const { data } = await axios.post('/avaliacao', checkedData);
  //     alert('Avaliação criada com sucesso!');
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   setEditando(false)
  // };

  const handleCloseModal = (e) => {
    setEditando(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const formatData = (data) => {
    return data?.toString()?.toLowerCase() || "";
  };

  const clear = () => {
    setFilters({});
  };

  return (
    <div onClick={() => setFiltrando(false)} className="">
      <h2 className="text-black text-2xl mt-4 mb-10 tracking-wider">
        Casos da Avaliação
      </h2>

      <div className="flex gap-5 justify-center items-center">
        <div
          onClick={(e) => {
            e.stopPropagation();
            setFiltrando(true);
          }}
          className="flex justify-center items-center gap-2 cursor-pointer mb-10"
        >
          <HiOutlineAdjustmentsHorizontal fontSize={23} />
          <p>Filtrar Elementos</p>
        </div>

        <div
          onClick={(e) => {
            e.stopPropagation();
            setFilters({});
          }}
          className="flex justify-center items-center gap-2 cursor-pointer mb-10"
        >
          <RiDeleteBin5Fill fontSize={23} />
          <p>Excluir Filtros</p>
        </div>
      </div>

      {filtrando && (
        <div className="modal-overlay overflow-y-auto">
          <div
            onClick={(e) => e.stopPropagation()}
            className="edit-captacao-modal !overflow-y-auto"
          >
            <form>
              {campos.map((cp) => (
                <label className="flex flex-col gap-2" key={cp} l>
                  <p>{mapInd[cp]}</p>
                  <input
                    placeholder={mapInd[cp]}
                    name={cp}
                    onChange={handleChange}
                    value={filters[cp]}
                    type={cp.includes("data") ? "date" : "text"}
                  />
                </label>
              ))}
            </form>
          </div>
        </div>
      )}

      {editando && (
        <div onClick={handleCloseModal} className="modal-overlay">
          <div
            onClick={(e) => e.stopPropagation()}
            className="edit-captacao-modal !overflow-y-scroll"
          >
            <form onSubmit={updateAvaliacao}>
              <label>
                Data de Captação:
                <input
                  type="date"
                  value={avaliacao.data_captacao?.split("T")[0] || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["data_captacao"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Data Última Vista:
                <input
                  type="date"
                  value={avaliacao.data_ultima_vista?.split("T")[0] || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["data_ultima_vista"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Processo:
                <input
                  type="text"
                  value={avaliacao.processo || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["processo"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Advogado:
                <input
                  type="text"
                  value={avaliacao.advogado || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["advogado"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Escritório:
                <input
                  type="text"
                  value={avaliacao.escritorio || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["escritorio"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Email:
                <input
                  type="text"
                  value={avaliacao.email}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["email"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Telefone
                <input
                  type="text"
                  value={avaliacao.telefone}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["telefone"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Classificação do Imóvel
                <input
                  type="text"
                  value={avaliacao.classificacao_imovel}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["classificacao_imovel"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Estado
                <select
                  value={avaliacao.estado || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["estado"]: e.target.value })
                  }
                  disabled
                >
                  <option value="">Selecione um estado</option>
                  <option value="Acre">Acre</option>
                  <option value="Alagoas">Alagoas</option>
                  <option value="Amapá">Amapá</option>
                  <option value="Amazonas">Amazonas</option>
                  <option value="Bahia">Bahia</option>
                  <option value="Ceará">Ceará</option>
                  <option value="Distrito Federal">Distrito Federal</option>
                  <option value="Espírito Santo">Espírito Santo</option>
                  <option value="Goiás">Goiás</option>
                  <option value="Maranhão">Maranhão</option>
                  <option value="Mato Grosso">Mato Grosso</option>
                  <option value="Mato Grosso do Sul">Mato Grosso do Sul</option>
                  <option value="Minas Gerais">Minas Gerais</option>
                  <option value="Pará">Pará</option>
                  <option value="Paraíba">Paraíba</option>
                  <option value="Paraná">Paraná</option>
                  <option value="Pernambuco">Pernambuco</option>
                  <option value="Piauí">Piauí</option>
                  <option value="Rio de Janeiro">Rio de Janeiro</option>
                  <option value="Rio Grande do Norte">
                    Rio Grande do Norte
                  </option>
                  <option value="Rio Grande do Sul">Rio Grande do Sul</option>
                  <option value="Rondônia">Rondônia</option>
                  <option value="Roraima">Roraima</option>
                  <option value="Santa Catarina">Santa Catarina</option>
                  <option value="São Paulo">São Paulo</option>
                  <option value="Sergipe">Sergipe</option>
                  <option value="Tocantins">Tocantins</option>
                </select>
              </label>
              <label>
                Nomeclatura
                <select
                  value={avaliacao.nomenclatura_captada || ""} // trocar termo de busca se necessario
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["nomenclatura_captada"]: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value="">Selecione uma nomeclatura</option>
                  <option value="Defiro a Penhora">Defiro a Penhora</option>
                  <option value="Avaliação do Imóvel">
                    Avaliação do Imóvel
                  </option>
                  <option value="Averbação da Penhora">
                    Averbação da Penhora
                  </option>
                  <option value="Escritório Fidelizado">
                    Escritório Fidelizado
                  </option>
                  <option value="Termo de Penhora">Termo de Penhora</option>
                  <option value="Nomeação Espontânea">
                    Nomeação Espontânea
                  </option>
                  <option value="Laudo de Avaliação">Laudo de Avaliação</option>
                  <option value="Leilão negativo">Leilão negativo</option>
                  <option value="Indique Leiloeiro">Indique Leiloeiro</option>
                  <option value="Indique Gestor">Indique Gestor</option>
                  <option value="Indicar Leiloeiro">Indicar Leiloeiro</option>
                  <option value="Indicar Gestor">Indicar Gestor</option>
                  <option value="Indicação de leiloeiro">
                    Indicação de leiloeiro
                  </option>
                  <option value="Leilão Extrajudicial">
                    Leilão Extrajudicial
                  </option>
                  <option value="Homologo">Homologo</option>
                  <option value="Realização da penhora">
                    Realização da penhora
                  </option>
                  <option value="Registro de Penhora">
                    Registro de Penhora
                  </option>
                  <option value="Hasta Pública">Hasta Pública</option>
                  <option value="Designação de Leilão">
                    Designação de Leilão
                  </option>
                  <option value="Venda Direta - TRT">Venda Direta - TRT</option>
                  <option value="Recuperação Judicial">
                    Recuperação Judicial
                  </option>
                  <option value="Escritório Fidelizado +">
                    Escritório Fidelizado +
                  </option>
                  <option value="Falência Judicial">Falência Judicial</option>
                </select>
              </label>
              <label>
                Relatório
                <select
                  value={avaliacao.relatorio || ""} // trocar termo de busca se necessario
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["relatorio"]: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value="">Selecione Aqui</option>
                  <option value="Rejeitado">Rejeitado</option>
                  <option value="Homologado">Homologado</option>
                  <option value="Pendente">Pendente</option>
                  <option value="Juntado">Juntado</option>
                  <option value="Não se enquadra">Não se enquadra</option>
                </select>
              </label>
              <label>
                Vara:
                <input
                  type="text"
                  value={avaliacao.vara || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["vara"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Valor da Ação:
                <input
                  type="text"
                  value={avaliacao.valor_acao || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["valor_acao"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Advogado Constituído:
                <select
                  value={avaliacao.adv_constituido || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["adv_constituido"]: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value={0}>Não</option>
                  <option value={1}>Sim</option>
                </select>
              </label>
              <label>
                Foro:
                <input
                  type="text"
                  value={avaliacao.foro || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["foro"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Juiz:
                <input
                  type="text"
                  value={avaliacao.juizo || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["juizo"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Cidade:
                <input
                  type="text"
                  value={avaliacao.cidade || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["cidade"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Bairro:
                <input
                  type="text"
                  value={avaliacao.bairro || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["bairro"]: e.target.value })
                  }
                  disabled
                />
              </label>
              <label>
                Observações do Captador:
                <input
                  type="text"
                  value={avaliacao.observacoes_captador || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["observacoes_captador"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Responsável:
                <input
                  type="text"
                  value={avaliacao.responsavel || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["responsavel"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>
              <label>
                Situação
                <select
                  disabled
                  value={avaliacao.situacao || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["situacao"]: e.target.value })
                  }
                >
                  <option value="">Selecione a situação aqui</option>
                  <option value="Nomeados">Nomeados</option>
                  <option value="Pendente">Pendente</option>
                  <option value="Acordo">Acordo</option>
                  <option value="Adv indicou outra leiloaria">
                    Adv indicou outra leiloaria
                  </option>
                  <option value="Juiz nomeou outra leiloaria">
                    Juiz nomeou outra leiloaria
                  </option>
                  <option value="Iminente (indicados)">
                    Iminente (indicados)
                  </option>
                  <option value="Processo extinto/arquivado">
                    Processo extinto/arquivado
                  </option>
                  <option value="Penhora levantada">Penhora levantada</option>
                  <option value="-">-</option>
                  <option value="Prejudicado">Prejudicado</option>
                </select>
              </label>
              <label>
                Tipo de Captação
                <select
                  value={avaliacao.tipo_captacao || "Mediata"}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["tipo_captacao"]: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value="Mediata">Mediata</option>
                  <option value="Imediata">Imediata</option>
                  <option value="Espontânea">Espontânea</option>
                </select>
              </label>
              <label>
                Numero de bens:
                <input
                  type="number"
                  value={avaliacao.num_bens || ""}
                  onChange={(e) =>
                    setAvaliacao({ ...avaliacao, ["num_bens"]: e.target.value })
                  }
                  disabled
                />
              </label>

              <label>
                Valor de Avaliação:
                <input
                  type="text"
                  value={avaliacao.valor_avaliacao || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["valor_avaliacao"]: e.target.value,
                    })
                  }
                  disabled
                />
              </label>

              <label>
                Endereço Completo:
                <input
                  type="text"
                  value={avaliacao.endereco_completo || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["endereco_completo"]: e.target.value,
                    })
                  }
                />
              </label>

              {/* <label>
                Diretório:
                <input
                  type="text"
                  value={avaliacao.diretorio || ""}
                  onChange={(e) =>
                    setAvaliacao({
                      ...avaliacao,
                      ["diretorio"]: e.target.value,
                    })
                  }
                />
              </label> */}
              <button className="bg-black text-white py-2 w-[50%] m-auto min-w-[400px]">
                Salvar Avaliação
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-700 transition-all ease-in-out">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              {campos.map((e) => (
                <th scope="col" className="px-6 py-3 bg-black" key={e}>
                  {mapInd[e]}
                </th>
              ))}
              <th className="bg-black">Editar</th>
            </tr>
          </thead>
          <tbody>
            {sortByDate(avaliacoes)
              .filter((av) => {
                // conave.log('filtrando:', Object.keys(filtrandoMinhas))
                return Object.keys(filters).every((key) =>
                  formatData(av[key]).includes(formatData(filters[key])),
                );
              })
              ?.slice(page * 10, page * 10 + 10)
              .map((av, i) => (
                <tr key={av.id}>
                  {campos.map((e) => (
                    <td key={av.id + e}>
                      {e.includes("data_") ? formatDate(av[e]) : av[e]}
                    </td>
                  ))}
                  <td>
                    <button
                      onClick={() => {
                        setEditando(true);
                        setAvaliacao(av);
                        setIndex(i);
                      }}
                      className="bg-black text-white px-4 py-2 hover:bg-gray-700 font-semibold"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-center mt-16 gap-5 items-center">
        <button
          className="px-5 py-1 disabled:!bg-gray-300 text-white bg-black"
          onClick={() => setPage(page - 1)}
          disabled={page == 0}
        >
          Anterior
        </button>
        <p>Página {page + 1}</p>
        <button className="px-5 py-1 !bg-black text-white" onClick={() => setPage(page + 1)}>Próxima</button>


        <NotificacaoDeErro
          mostrar={mostrarNotificacaoDeErro}
          mensagem={msn}
          onClose={() => setMostrarNotificacaoDeErro(false)}
        />

        <NotificacaoDeSucesso
          mostrar={mostrarNotificacaoDeSucesso}
          mensagem={msn}
          onClose={() => setMostrarNotificacaoDeSucesso(false)}
        />
      </div>

     

    </div>
  );
}

export default AvaliacaoForm;
